import axios from 'axios';

const client = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'https://funnytask.net/api',
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('ft_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Token HẾT HẠN / không hợp lệ (401): xoá token + báo cho app đưa về màn ĐĂNG NHẬP, thay vì để
// màn hình kẹt "báo lỗi" (hay gặp trên app native khi token cũ hết hạn còn web thì vừa login lại).
client.interceptors.response.use(
  (r) => r,
  (err) => {
    // KHÔNG chặn theo "còn token hay không": token có thể đã bị xoá bởi một 401 trước đó, và khi
    // ấy sự kiện không phát ra nữa -> màn hình kẹt lại báo "Chưa đăng nhập" mà không ai đưa về
    // trang đăng nhập (đúng cái bẫy ở màn khoá Lionjob: nó hỏi mã code trong khi lỗi thật là hết
    // phiên). Trừ chính lời gọi đăng nhập, vì 401 ở đó là sai tài khoản/mật khẩu.
    const isLogin = /\/auth\/login$/.test(err?.config?.url || '');
    if (err?.response?.status === 401 && !isLogin) {
      localStorage.removeItem('ft_token');
      try { window.dispatchEvent(new CustomEvent('ft:auth-expired')); } catch { /* ignore */ }
    }
    return Promise.reject(err);
  }
);

export default client;
